import _ from "lodash";
import ls from "./localStorage";
import jwtDecode from "jwt-decode";
import { v4 as uuidv4 } from "uuid";

const USR_MENU_VAR = `lottery_menu_config`.toUpperCase(),
  PAGE_TITLE_VAR = `Tu Jugada RD`,
  ADMIN_PAGE_TITLE_VAR = `${PAGE_TITLE_VAR} (Admin)`,
  apiLsVariable = `lottery-rd-session`.toUpperCase(),
  apiLsClientVariable = `lottery-rd-client-session`.toUpperCase(),
  apiLsDarkModeVariable = `IDM`.toUpperCase(),
  serverDateFormat = "YYYY-MM-DD H:s:i",
  rouletteCookieName = "wrtjrd";
const stringInitials = ($string) => {
  let initials = $string.match(/\b\w/g) || [];
  initials = initials.join("").toUpperCase();
  return initials;
};

export const normalizeStringMatch = (input) => {
  return input
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
};

export const formatBankName = (name) => {
  if (!name) return name || "";
  if (typeof name !== "string") return name;

  const normalized = normalizeStringMatch(name).replace(/[-_]+/g, " ");

  if (/\b(bhd|leon)\b/.test(normalized)) return "Banco BHD León";
  if (/\b(reservas|banreservas)\b/.test(normalized)) return "Banco de Reservas";
  if (
    /\b(popular|bpd)\b/.test(normalized) &&
    !normalized.includes("asociacion")
  )
    return "Banco Popular";
  if (/\b(santa cruz)\b/.test(normalized)) return "Banco Santa Cruz";
  if (/\b(caribe)\b/.test(normalized)) return "Banco Caribe";
  if (/\b(progreso)\b/.test(normalized)) return "Banco del Progreso";
  if (/\b(vimenca|vim banco)\b/.test(normalized)) return "Banco Vimenca";
  if (/\b(ademi)\b/.test(normalized)) return "Banco Ademi";
  if (/\b(lopez de haro)\b/.test(normalized)) return "Banco López de Haro";
  if (/\b(bdi)\b/.test(normalized)) return "Banco BDI";
  if (/\b(promerica)\b/.test(normalized)) return "Banco Promerica";
  if (/\b(banesco)\b/.test(normalized)) return "Banco Banesco";
  if (/\b(adopem)\b/.test(normalized)) return "Banco ADOPEM";
  if (/\b(union)\b/.test(normalized)) return "Banco Unión";
  if (/\b(banfondesa)\b/.test(normalized)) return "Banfondesa";
  if (/\b(cibao)\b/.test(normalized)) return "Asociacion Cibao";
  if (/\b(apap|asociacion popular)\b/.test(normalized))
    return "Asociacion Popular";
  if (/\b(zelle)\b/.test(normalized)) return "ZELLE";
  if (/\b(cashapp)\b/.test(normalized)) return "CASHAPP";
  if (/\b(qik)\b/.test(normalized)) return "QIK";
  if (/\b(paypal)\b/.test(normalized)) return "PayPal";

  return normalized
    .split(" ")
    .map((word) => {
      if (word === "de" || word === "del") return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ")
    .trim();
};

export const formatDni = (value) => {
  if (!value) return "";
  const cleaned = ("" + value).replace(/\D/g, "");
  const match = cleaned.match(/^(\d{3})(\d{7})(\d{1})$/);
  if (match) {
    return `${match[1]}-${match[2]}-${match[3]}`;
  }
  return value;
};

export const formatPhone = (value) => {
  if (!value) return "";
  const cleaned = ("" + value).replace(/\D/g, "");
  const match = cleaned.match(/^1?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }
  return value;
};

export const formatAccountName = (name) => {
  if (!name) return name || "";
  if (typeof name !== "string") return name;

  const normalized = normalizeStringMatch(name);

  if (normalized.includes("zelle")) return "Zelle";
  if (normalized.includes("bpd telesaldo")) return "BPD TeleSaldo";
  if (
    normalized.includes("banreservas telesaldo") ||
    normalized.includes("reservas telesaldo")
  )
    return "Banreservas TeleSaldo";
  if (normalized.includes("smr 9993") || normalized.includes("smr9993"))
    return "Banreservas SMR 9993";
  if (normalized.includes("bp 3094") || normalized.includes("bp3094"))
    return "Banreservas BP 3094";
  if (normalized.includes("bhd telesaldo")) return "BHD TeleSaldo";
  if (normalized.includes("jomil 1909") || normalized.includes("jomil1909"))
    return "BPD JOMIL 1909";
  if (normalized.includes("wb 7565") || normalized.includes("wb7565"))
    return "BPD WB 7565";
  if (normalized.includes("bp 7897") || normalized.includes("bp7897"))
    return "BPD BP 7897";
  if (
    normalized.includes("bpd telecargas 2415") ||
    normalized.includes("telecargas 2415")
  )
    return "BPD TELECARGAS 2415";
  if (
    normalized.includes("banreservas telecargas 6705") ||
    normalized.includes("telecargas 6705")
  )
    return "Banreservas TELECARGAS 6705";
  if (normalized.includes("bono")) return "Bono";
  if (normalized.includes("usdt")) return "USDT";
  if (normalized.includes("paypal")) return "PAYPAL";
  if (normalized.includes("stripe")) return "STRIPE";
  if (normalized.includes("jm cta")) return "JM CTA";
  if (normalized.includes("skychain")) return "SKYCHAIN";
  if (normalized.includes("paywall")) return "PAYWALL";
  if (normalized.includes("distribucion")) return "Distribucion";
  if (normalized.includes("cashapp")) return "CASHAPP";

  return name.trim();
};

const getUserData = (token = "") => {
  if (token && token !== "") {
    const decodedToken = jwtDecode(token);
    const userData = decodedToken.user;
    if (typeof userData !== "undefined") {
      return userData;
    }
  }
  return null;
};

const getTokenData = (token = "") => {
  if (token && token !== "") {
    const decodedToken = jwtDecode(token);
    return decodedToken;
  }
  return null;
};

const isValidEmail = (email) => {
  return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);
};

const strongPassword = (password = "") => {
  if (!password) return -1;
  /*eslint no-useless-escape: "error"*/
  const strongRegex = new RegExp(
    "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})"
  );
  const mediumRegex = new RegExp(
    "^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})"
  );
  if (strongRegex.test(password)) {
    return 1;
  } else if (mediumRegex.test(password)) {
    return 0;
  } else {
    return -1;
  }
};

const storeMenus = (menu) => {
  try {
    ls.set(USR_MENU_VAR, window.btoa(JSON.stringify(menu)));
    return true;
  } catch (error) {
    console.error("ERROR: ", error);
  }
  return false;
};

const getStoredMenus = () => {
  try {
    let data = ls.get(USR_MENU_VAR) || null;
    if (data) data = JSON.parse(window.atob(data));
    return data;
  } catch (error) {
    console.error("ERROR: ", error);
  }
  return null;
};

const roles = {
  admin: {
    ROLE_ADMIN: "ROLE_ADMIN",
    ROLE_USER: "ROLE_USER",
    ROLE_USERS: "ROLE_USERS",
    ROLE_USERS_IDENTITY_VERIFICATIONS: "ROLE_USERS_IDENTITY_VERIFICATIONS",
    ROLE_USERS_IDENTITY_VERIFICATIONS_REVIEW:
      "ROLE_USERS_IDENTITY_VERIFICATIONS_REVIEW",
    ROLE_USERS_IDENTITY_VERIFICATIONS_EDIT:
      "ROLE_USERS_IDENTITY_VERIFICATIONS_EDIT",
    ROLE_ADMINS: "ROLE_ADMINS",
    ROLE_ADMINS_CREATE: "ROLE_ADMINS_CREATE",
    ROLE_ADMINS_UPDATE: "ROLE_ADMINS_UPDATE",
    ROLE_ADMINS_DELETE: "ROLE_ADMINS_DELETE",
    ROLE_USERS_UPDATE: "ROLE_USERS_UPDATE",
    ROLE_USERS_ACTIVATE: "ROLE_USERS_ACTIVATE",
    ROLE_USERS_BALANCE_UNLOCK: "ROLE_USERS_BALANCE_UNLOCK",
    ROLE_USERS_SYNC_BALANCE: "ROLE_USERS_SYNC_BALANCE",
    ROLE_USERS_DESACTIVATE: "ROLE_USERS_DESACTIVATE",
    ROLE_USERS_DELETE: "ROLE_USERS_DELETE",
    ROLE_USERS_IMPERSONATION: "ROLE_USERS_IMPERSONATION",
    ROLE_USERS_RESET_PASSWORD: "ROLE_USERS_RESET_PASSWORD",
    ROLE_USERS_COMMISSIONS_PERCENTAGE_ASSIGN:
      "ROLE_USERS_COMMISSIONS_PERCENTAGE_ASSIGN",
    ROLE_USERS_REFERRED: "ROLE_USERS_REFERRED",
    ROLE_LOTTERIES: "ROLE_LOTTERIES",
    ROLE_LOTTERIES_CREATE: "ROLE_LOTTERIES_CREATE",
    ROLE_LOTTERIES_UPDATE: "ROLE_LOTTERIES_UPDATE",
    ROLE_LOTTERIES_DELETE: "ROLE_LOTTERIES_DELETE",
    ROLE_RAFFLES: "ROLE_RAFFLES",
    ROLE_RAFFLES_SAVE: "ROLE_RAFFLES_SAVE",
    ROLE_RAFFLES_DELETE: "ROLE_RAFFLES_DELETE",
    ROLE_BLOCKS: "ROLE_BLOCKS",
    ROLE_BLOCKS_CREATE: "ROLE_BLOCKS_CREATE",
    ROLE_BLOCKS_UPDATE: "ROLE_BLOCKS_UPDATE",
    ROLE_BLOCKS_DELETE: "ROLE_BLOCKS_DELETE",
    ROLE_PROMOTIONS: "ROLE_PROMOTIONS",
    ROLE_PROMOTIONS_CREATE: "ROLE_PROMOTIONS_CREATE",
    ROLE_PROMOTIONS_UPDATE: "ROLE_PROMOTIONS_UPDATE",
    ROLE_PROMOTIONS_DELETE: "ROLE_PROMOTIONS_DELETE",
    ROLE_BIRTHDAY_PROMOTIONS: "ROLE_BIRTHDAY_PROMOTIONS",
    ROLE_BIRTHDAY_PROMOTIONS_CREATE: "ROLE_BIRTHDAY_PROMOTIONS_CREATE",
    ROLE_BIRTHDAY_PROMOTIONS_UPDATE: "ROLE_BIRTHDAY_PROMOTIONS_UPDATE",
    ROLE_BIRTHDAY_PROMOTIONS_DELETE: "ROLE_BIRTHDAY_PROMOTIONS_DELETE",
    ROLE_TRANSACTIONS: "ROLE_TRANSACTIONS",
    ROLE_TRANSACTIONS_PROCESS: "ROLE_TRANSACTIONS_PROCESS",
    ROLE_TRANSACTIONS_CANCEL: "ROLE_TRANSACTIONS_CANCEL",
    ROLE_TRANSACTIONS_APPROVE: "ROLE_TRANSACTIONS_APPROVE",
    ROLE_TRANSACTIONS_WITHDRAW_REVIEW: "ROLE_TRANSACTIONS_WITHDRAW_REVIEW",
    ROLE_TRANSACTIONS_REJECT: "ROLE_TRANSACTIONS_REJECT",
    ROLE_TRANSACTIONS_CONFIRM: "ROLE_TRANSACTIONS_CONFIRM",
    ROLE_TRANSACTIONS_SUPER_APPROVE: "ROLE_TRANSACTIONS_SUPER_APPROVE",
    ROLE_TRANSACTIONS_ADD_USER_NOTE: "ROLE_TRANSACTIONS_ADD_USER_NOTE",
    ROLE_BALANCE_MOVEMENTS: "ROLE_BALANCE_MOVEMENTS",
    ROLE_BALANCE_MOVEMENT_REGULARIZE: "ROLE_BALANCE_MOVEMENT_REGULARIZE",
    ROLE_COMMISSIONS_GENERATE: "ROLE_COMMISSIONS_GENERATE",
    ROLE_COMMISSIONS_PROCESS: "ROLE_COMMISSIONS_PROCESS",
    ROLE_ORDERS: "ROLE_ORDERS",
    ROLE_ORDERS_CANCEL: "ROLE_ORDERS_CANCEL",
    ROLE_PROCESS_WINNING: "ROLE_PROCESS_WINNING",
    ROLE_RAFFLES_ASSIGN_RESULTS: "ROLE_RAFFLES_ASSIGN_RESULTS",
    ROLE_USER_COMMISSION_PROFILES: "ROLE_USER_COMMISSION_PROFILES",
    ROLE_USER_COMMISSION_PROFILES_CREATE:
      "ROLE_USER_COMMISSION_PROFILES_CREATE",
    ROLE_USER_COMMISSION_PROFILES_UPDATE:
      "ROLE_USER_COMMISSION_PROFILES_UPDATE",
    ROLE_USER_COMMISSION_PROFILES_DELETE:
      "ROLE_USER_COMMISSION_PROFILES_DELETE",
    ROLE_MONITORING_REPORT: "ROLE_MONITORING_REPORT",
    ROLE_LOTTERIES_CLOSING_SCHEDULE: "ROLE_LOTTERIES_CLOSING_SCHEDULE",
    ROLE_USER_TRANSACTION_PROFILES: "ROLE_USER_TRANSACTION_PROFILES",
    ROLE_USER_TRANSACTION_PROFILES_CREATE:
      "ROLE_USER_TRANSACTION_PROFILES_CREATE",
    ROLE_USER_TRANSACTION_PROFILES_UPDATE:
      "ROLE_USER_TRANSACTION_PROFILES_UPDATE",
    ROLE_USER_TRANSACTION_PROFILES_DELETE:
      "ROLE_USER_TRANSACTION_PROFILES_DELETE",
    ROLE_RAFFLES_CONFIRM: "ROLE_RAFFLES_CONFIRM",
    ROLE_USER_CREDIT_CARD_MODIFY: "ROLE_USER_CREDIT_CARD_MODIFY",
    ROLE_TRANSACTIONS_WITHDRAW_REJECT: "ROLE_TRANSACTIONS_WITHDRAW_REJECT",
    ROLE_TRANSACTIONS_WITHDRAW_APPROVE: "ROLE_TRANSACTIONS_WITHDRAW_APPROVE",
    ROLE_TRANSACTIONS_DEPOSIT_REJECT: "ROLE_TRANSACTIONS_DEPOSIT_REJECT",
    ROLE_TRANSACTIONS_DEPOSIT_PRE_APPROVE:
      "ROLE_TRANSACTIONS_DEPOSIT_PRE_APPROVE",
    ROLE_TRANSACTIONS_DEPOSIT_APPROVE: "ROLE_TRANSACTIONS_DEPOSIT_APPROVE",
    ROLE_TRANSACTIONS_DEPOSIT_REFUND_REQUEST:
      "ROLE_TRANSACTIONS_DEPOSIT_REFUND_REQUEST",
    ROLE_TRANSACTIONS_DEPOSIT_REFUND_PROCESS:
      "ROLE_TRANSACTIONS_DEPOSIT_REFUND_PROCESS",
    ROLE_DEPOSIT_ACCOUNT_GROUPS: "ROLE_DEPOSIT_ACCOUNT_GROUPS",
    ROLE_DEPOSIT_ACCOUNT_GROUPS_CREATE: "ROLE_DEPOSIT_ACCOUNT_GROUPS_CREATE",
    ROLE_DEPOSIT_ACCOUNT_GROUPS_UPDATE: "ROLE_DEPOSIT_ACCOUNT_GROUPS_UPDATE",
    ROLE_DEPOSIT_ACCOUNT_GROUPS_DELETE: "ROLE_DEPOSIT_ACCOUNT_GROUPS_DELETE",
    ROLE_OPERATION_GROUPS: "ROLE_OPERATION_GROUPS",
    ROLE_OPERATION_GROUPS_CREATE: "ROLE_OPERATION_GROUPS_CREATE",
    ROLE_OPERATION_GROUPS_UPDATE: "ROLE_OPERATION_GROUPS_UPDATE",
    ROLE_OPERATION_GROUPS_DELETE: "ROLE_OPERATION_GROUPS_DELETE",
    ROLE_PROMOTION_RAFFLES: "ROLE_PROMOTION_RAFFLES",
    ROLE_PROMOTION_RAFFLES_CREATE: "ROLE_PROMOTION_RAFFLES_CREATE",
    ROLE_PROMOTION_RAFFLES_UPDATE: "ROLE_PROMOTION_RAFFLES_UPDATE",
    ROLE_PROMOTION_RAFFLES_INITIATE: "ROLE_PROMOTION_RAFFLES_INITIATE",
    ROLE_RANKING_POINTS_VIEW: "ROLE_RANKING_POINTS_VIEW",
    ROLE_RANKING_POINTS_MANAGE: "ROLE_RANKING_POINTS_MANAGE",
    ROLE_RANKING_POINTS_ASSIGN_POINTS: "ROLE_RANKING_POINTS_ASSIGN_POINTS",
    ROLE_PROMOTION_RAFFLES_CLOSE: "ROLE_PROMOTION_RAFFLES_CLOSE",
    ROLE_PROMOTION_RAFFLE_PAY: "ROLE_PROMOTION_RAFFLE_PAY",
    ROLE_ADS: "ROLE_ADS",
    ROLE_ADS_CREATE: "ROLE_ADS_CREATE",
    ROLE_ADS_UPDATE: "ROLE_ADS_UPDATE",
    ROLE_ADS_DELETE: "ROLE_ADS_DELETE",
    ROLE_SCHEDULED_PROMOTION_RAFFLES: "ROLE_SCHEDULED_PROMOTION_RAFFLES",
    ROLE_SCHEDULED_PROMOTION_RAFFLES_CREATE:
      "ROLE_SCHEDULED_PROMOTION_RAFFLES_CREATE",
    ROLE_SCHEDULED_PROMOTION_RAFFLES_UPDATE:
      "ROLE_SCHEDULED_PROMOTION_RAFFLES_UPDATE",
    ROLE_WORKING_HOURS: "ROLE_WORKING_HOURS",
    ROLE_WORKING_HOURS_UPDATE: "ROLE_WORKING_HOURS_UPDATE",
    ROLE_EMAIL_TEMPLATES: "ROLE_EMAIL_TEMPLATES",
    ROLE_EMAIL_TEMPLATES_UPDATE: "ROLE_EMAIL_TEMPLATES_UPDATE",
    ROLE_REDIS_QUOTAS: "ROLE_REDIS_QUOTAS",
    ROLE_REDIS_QUOTAS_UNBLOCK: "ROLE_REDIS_QUOTAS_UNBLOCK",
    ROLE_REDIS_QUOTAS_PLAY_LIMITS_VIEW: "ROLE_REDIS_QUOTAS_PLAY_LIMITS_VIEW",
    ROLE_REDIS_QUOTAS_PLAY_LIMITS_UPDATE:
      "ROLE_REDIS_QUOTAS_PLAY_LIMITS_UPDATE",
    ROLE_USERS_AUTO_APPROVE_TRANSACTIONS:
      "ROLE_USERS_AUTO_APPROVE_TRANSACTIONS",
    ROLE_TIPS: "ROLE_TIPS",
    ROLE_TIPS_EXPORT: "ROLE_TIPS_EXPORT",
  },
  client: {
    ROLE_SELLER: "ROLE_SELLER",
    ROLE_BUYER: "ROLE_BUYER",
    ROLE_TERMINAL: "ROLE_TERMINAL",
    ROLE_ECB: "ROLE_ECB",
    ROLE_ALLM: "ROLE_ALLM",
    ROLE_ARM: "ROLE_ARM",
    ROLE_AFDM: "ROLE_AFDM",
    ROLE_AFRM: "ROLE_AFRM",
    ROLE_AAPM: "ROLE_AAPM",
    ROLE_ADRM: "ROLE_ADRM",
    ROLE_ALSM: "ROLE_ALSM",
    ROLE_ASDM: "ROLE_ASDM",
    ROLE_APM: "ROLE_APM",
    ROLE_ASA: "ROLE_ASA",
    ROLE_ARPM: "ROLE_ARPM",
  },
};

const getEffectiveRoles = (user = {}) => {
  let rolesArray = [...(user.accessRoles || [])];
  if (user.ist && !rolesArray.includes(roles.client.ROLE_TERMINAL)) {
    rolesArray.push(roles.client.ROLE_TERMINAL);
  }
  if (user.asa && !rolesArray.includes(roles.client.ROLE_ASA)) {
    rolesArray.push(roles.client.ROLE_ASA);
  }
  if (user.ecb && !rolesArray.includes(roles.client.ROLE_ECB)) {
    rolesArray.push(roles.client.ROLE_ECB);
  }
  if (user.allm && !rolesArray.includes(roles.client.ROLE_ALLM)) {
    rolesArray.push(roles.client.ROLE_ALLM);
  }
  if (user.arm && !rolesArray.includes(roles.client.ROLE_ARM)) {
    rolesArray.push(roles.client.ROLE_ARM);
  }
  if (user.afdm && !rolesArray.includes(roles.client.ROLE_AFDM)) {
    rolesArray.push(roles.client.ROLE_AFDM);
  }
  if (user.afrm && !rolesArray.includes(roles.client.ROLE_AFRM)) {
    rolesArray.push(roles.client.ROLE_AFRM);
  }
  if (user.aapm && !rolesArray.includes(roles.client.ROLE_AAPM)) {
    rolesArray.push(roles.client.ROLE_AAPM);
  }
  if (user.adrm && !rolesArray.includes(roles.client.ROLE_ADRM)) {
    rolesArray.push(roles.client.ROLE_ADRM);
  }
  if (user.alsm && !rolesArray.includes(roles.client.ROLE_ALSM)) {
    rolesArray.push(roles.client.ROLE_ALSM);
  }
  if (user.asdm && !rolesArray.includes(roles.client.ROLE_ASDM)) {
    rolesArray.push(roles.client.ROLE_ASDM);
  }
  if (user.apm && !rolesArray.includes(roles.client.ROLE_APM)) {
    rolesArray.push(roles.client.ROLE_APM);
  }
  if (user.arpm && !rolesArray.includes(roles.client.ROLE_ARPM)) {
    rolesArray.push(roles.client.ROLE_ARPM);
  }
  return [...new Set(rolesArray)];
};

const hasRoles = (userRoles = [], assignedRoles = []) => {
  // If userRoles is actually a user object, normalize it
  if (userRoles && !_.isArray(userRoles) && _.isObject(userRoles)) {
    userRoles = getEffectiveRoles(userRoles);
  }

  assignedRoles = [...assignedRoles, ...[roles.admin.ROLE_ADMIN]];
  if (!assignedRoles || !_.isArray(assignedRoles)) return false;
  if (!userRoles || !_.isArray(userRoles)) return false;
  return _.intersection(userRoles, assignedRoles).length > 0;
};

const getBase64 = (img, callback) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
};

const maskDni = (dni) => {
  if (!dni) return "";
  return dni.toString().replace(/^(\d{3})(\d{7})(\d{1})$/, "$1-$2-$3");
};

const maskPhone = (phone) => {
  if (!phone) return "";
  return phone.toString().replace(/^(\d{3})(\d{7})(\d{1})$/, "$1-$2-$3");
};

const pageTitle = (title) => {
  if (!title) return PAGE_TITLE_VAR;
  return `${PAGE_TITLE_VAR} - ${title}`;
};

const adminPageTitle = (title) => {
  if (!title) return ADMIN_PAGE_TITLE_VAR;
  return `${ADMIN_PAGE_TITLE_VAR} - ${title}`;
};

const getYear = () => {
  const date = new Date();
  const year = date.getFullYear();
  return year === 2022 ? 2022 : `2022-${year}`;
};

const generateUniqueID = () => {
  return uuidv4();
};

const CRAUE_CONFIG = {
  VAR_REFERRAL_COMMISSION_APPLY_AFTER_SPEND_AMOUNT:
    "referral_commission_apply_after_spend_amount",
  VAR_USER_COMMISSIONS_OPTIONS: "user_commissions_options",
  VAR_USER_REFERRAL_COMMISSION_AMOUNT: "user_referral_commission_amount",
  VAR_USER_REFERRAL_RULES: "user_referral_rules",
  VAR_VERIFY_PHONE: "verify_phone",
  VAR_CAROUSEL_HOME_PAGE_CLIENT: "carousel_home_page_client",
  VAR_FREQUENTLY_ASKED_QUESTIONS: "frequently_asked_questions",
};

const PAYMENT_CLIENTS = {
  CHARGEMONEY: "CHARGEMONEY",
  MONEYGRATOR: "MONEYGRATOR",
  PAYWALL: "PAYWALL",
  SKYCHAIN: "SKYCHAIN",
  PAYCOMBAT: "PAYCOMBAT",
  MATREVIC: "MATREVIC",
};

const DATE_FORMAT = {
  MOMENT_DATE_TIME: "DD/MM/YYYY hh:mm A",
  MOMENT_DATE_TIME_LONG: "DD/MM/YYYY hh:mm:ss A",
  MOMENT_DAY_MONTH: "DD MMM",
  MOMENT_DAY_MONTH_YEAR: "DD MMM YYYY",
  MOMENT_DATE: "DD/MM/YYYY",
  MOMENT_TIME: "hh:mm A",
  MOMENT_TIME_LONG: "hh:mm:ss A",
  SERVER_DATE_TIME: "YYYY-MM-DD hh:mm:ss",
  SERVER_DATE: "YYYY-MM-DD",
  SERVER_TIME: "hh:mm:ss",
  SERVER_24_HOUR_TIME: "HH:mm:ss",
  TIMEZONE: "America/Santo_Domingo",
  // format: Sáb 31 enero • 11:00 am
  MOMENT_RAFFLE_DATE: "ddd DD MMMM",
};

const PLAY_TYPES = {
  QUINIELA: "quiniela",
  PALE: "pale",
  TRIPLET: "tripleta",
  SUPERPALE: "superpale",
  SUPERQUINIELA: "superquiniela",
  AUTO: "auto",
  PICK_3: "pick3",
  PICK_4: "pick4",
  CHANCE: "chance",
  DOBLE_CHANCE: "doble_chance",
  TRIPLE_CHANCE: "triple_chance",
};

const numbersCombinations = (play) => {
  const numbers = play.split("-");
  const combinations = [];
  switch (numbers.length) {
    case 2:
      combinations.push(`${numbers[0]}-${numbers[1]}`);
      combinations.push(`${numbers[1]}-${numbers[0]}`);
      break;
    case 3:
      combinations.push(`${numbers[0]}-${numbers[1]}-${numbers[2]}`);
      combinations.push(`${numbers[0]}-${numbers[2]}-${numbers[1]}`);
      combinations.push(`${numbers[1]}-${numbers[0]}-${numbers[2]}`);
      combinations.push(`${numbers[1]}-${numbers[2]}-${numbers[0]}`);
      combinations.push(`${numbers[2]}-${numbers[0]}-${numbers[1]}`);
      combinations.push(`${numbers[2]}-${numbers[1]}-${numbers[0]}`);
      break;
    case 4:
      combinations.push(
        `${numbers[0]}-${numbers[1]}-${numbers[2]}-${numbers[3]}`
      );
      combinations.push(
        `${numbers[0]}-${numbers[1]}-${numbers[3]}-${numbers[2]}`
      );
      combinations.push(
        `${numbers[0]}-${numbers[2]}-${numbers[1]}-${numbers[3]}`
      );
      combinations.push(
        `${numbers[0]}-${numbers[2]}-${numbers[3]}-${numbers[1]}`
      );
      combinations.push(
        `${numbers[0]}-${numbers[3]}-${numbers[1]}-${numbers[2]}`
      );
      combinations.push(
        `${numbers[0]}-${numbers[3]}-${numbers[2]}-${numbers[1]}`
      );

      combinations.push(
        `${numbers[1]}-${numbers[0]}-${numbers[2]}-${numbers[3]}`
      );
      combinations.push(
        `${numbers[1]}-${numbers[0]}-${numbers[3]}-${numbers[2]}`
      );
      combinations.push(
        `${numbers[1]}-${numbers[2]}-${numbers[0]}-${numbers[3]}`
      );
      combinations.push(
        `${numbers[1]}-${numbers[2]}-${numbers[3]}-${numbers[0]}`
      );
      combinations.push(
        `${numbers[1]}-${numbers[3]}-${numbers[0]}-${numbers[2]}`
      );
      combinations.push(
        `${numbers[1]}-${numbers[3]}-${numbers[2]}-${numbers[0]}`
      );

      combinations.push(
        `${numbers[2]}-${numbers[0]}-${numbers[1]}-${numbers[3]}`
      );
      combinations.push(
        `${numbers[2]}-${numbers[0]}-${numbers[3]}-${numbers[1]}`
      );
      combinations.push(
        `${numbers[2]}-${numbers[1]}-${numbers[0]}-${numbers[3]}`
      );
      combinations.push(
        `${numbers[2]}-${numbers[1]}-${numbers[3]}-${numbers[0]}`
      );
      combinations.push(
        `${numbers[2]}-${numbers[3]}-${numbers[0]}-${numbers[1]}`
      );
      combinations.push(
        `${numbers[2]}-${numbers[3]}-${numbers[1]}-${numbers[0]}`
      );

      combinations.push(
        `${numbers[3]}-${numbers[0]}-${numbers[1]}-${numbers[2]}`
      );
      combinations.push(
        `${numbers[3]}-${numbers[0]}-${numbers[2]}-${numbers[1]}`
      );
      combinations.push(
        `${numbers[3]}-${numbers[1]}-${numbers[0]}-${numbers[2]}`
      );
      combinations.push(
        `${numbers[3]}-${numbers[1]}-${numbers[2]}-${numbers[0]}`
      );
      combinations.push(
        `${numbers[3]}-${numbers[2]}-${numbers[0]}-${numbers[1]}`
      );
      combinations.push(
        `${numbers[3]}-${numbers[2]}-${numbers[1]}-${numbers[0]}`
      );
      break;
    default:
      combinations.push(play);
  }
  return combinations;
};

const validateEmail = (value = []) => {
  return value.filter((email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  });
};

const toBase64 = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });
};

const getCookie = (name) => {
  try {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      const cookieParts = cookie.split("=");
      if (cookieParts[0] === name) {
        return decodeURIComponent(atob(cookieParts[1]));
      }
    }
  } catch (error) {
    return null;
  }
  return null;
};

const saveCookie = (name, value, days) => {
  const expirationDate = new Date();
  var numberOfMiliseconds = expirationDate.getTime();
  var newExpirationDate = new Date(numberOfMiliseconds + days);

  const cookieValue = `${name.trim()}=${btoa(
    encodeURIComponent(value)
  )}; expires=${newExpirationDate.toUTCString()}; path=/`;
  document.cookie = cookieValue;
};

const saveCookieEncode = (name, value, hours) => {
  const expirationDate = new Date();
  var numberOfMiliseconds = expirationDate.getTime();
  var newExpirationDate = new Date(
    numberOfMiliseconds + hours * 60 * 60 * 1000
  );

  const cookieValue = `${btoa(name.trim())}[tjrd]${btoa(
    encodeURIComponent(value)
  )}; expires=${newExpirationDate.toUTCString()}; path=/`;
  document.cookie = cookieValue;
};

const cookieEncodeExists = (name, value) => {
  try {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      const cookieParts = cookie.split("[tjrd]");
      if (
        cookieParts[0] === btoa(name) &&
        decodeURIComponent(atob(cookieParts[1])) === value
      ) {
        return true;
      }
    }
  } catch (error) {
    return false;
  }
};

const countryWithIso = (isoCode = "do") =>
  ({
    DO: "RD",
    US: "USA",
    ES: "ESP",
    FR: "FRA",
    IT: "ITA",
    GB: "GBR",
  }[isoCode?.toUpperCase()] || isoCode);

const isMobileDevice = () => {
  //  test all mobile devices
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

export {
  USR_MENU_VAR,
  PAGE_TITLE_VAR,
  apiLsVariable,
  apiLsClientVariable,
  apiLsDarkModeVariable,
  jwtDecode,
  stringInitials,
  getEffectiveRoles,
  getUserData,
  isValidEmail,
  strongPassword,
  storeMenus,
  getStoredMenus,
  hasRoles,
  roles,
  getBase64,
  maskDni,
  serverDateFormat,
  pageTitle,
  adminPageTitle,
  getYear,
  CRAUE_CONFIG,
  DATE_FORMAT,
  generateUniqueID,
  PLAY_TYPES,
  numbersCombinations,
  validateEmail,
  toBase64,
  PAYMENT_CLIENTS,
  getCookie,
  saveCookie,
  rouletteCookieName,
  saveCookieEncode,
  cookieEncodeExists,
  countryWithIso,
  isMobileDevice,
  getTokenData,
  maskPhone,
};
